export default {
  computed: {
    // @TODO: Share
    tokenId() {
      if (!this.sprite) return '';
      let { tokenId } = this.sprite;
      if (tokenId && tokenId.indexOf && tokenId.indexOf('-') !== -1) tokenId = undefined;
      return tokenId;
    },
    readyToEvolve() {
      return false; // @TODO: We are disabling this feature for now
      if (!this.size || !this.sprite || !this.tokenId) return false;
      if (!this.sprite.evolution) this.sprite.evolution = 0;
      return this.size === 'large' && this.sprite.evolution === 0 && this.sprite.level > 5;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/evolve.js